import React from 'react'
import { useHistory } from 'react-router-dom'
import './index.less'
import arrow from '@/assets/image/arrow-black.png';

import ServiceModal from '@/components/ServiceModal';

export default function Page6() {
  const history = useHistory()
  return (
    <div className="home-join">
      <div className="home-join-inner">
          <span className='home-join-inner-text'>数秦科技诚邀您加入可信数据空间，实现数据价值共创</span>
          <ServiceModal>
            <button className='home-join-inner-button'>
              立即加入
              <img src={arrow} />
            </button>
          </ServiceModal>
      </div>
    </div>
  )
}
